import { Search } from "../components/Search";
import { DataSection } from "../components/DataSection";

export default function Root() {
  return (
    <>
      <Search />
      <DataSection />
    </>
  );
};